import React from 'react';
import utils from '../Utils';

require('./resumeQuantity.css');

const ResumeQuantity = ({
    title,
    symbol,
    amount,
    proportionChange,
    percentageChange,
    period,
    icon,
    backgroundColor,
    onClick
  }) => {
    const changeValue = proportionChange ? proportionChange.toFixed(1) : Math.round(percentageChange)
    const isIncrease = changeValue >= 0;

    return (
        <div>
            <div className='rounded'>
                <div className='text-center clickeable' onClick={onClick}>
                    <div className={`resumeIcon m-auto bg-gradient ${backgroundColor}`}>
                        <img className='m-auto' src={process.env.PUBLIC_URL +  '/img/' + icon } alt="Descripción de la imagen" />
                    </div>
                    <div className='d-flex flex-column align-items-center'>
                        <p className='text-muted mb-0'>{title}</p>
                        <p className='quantityResume mb-0'>{symbol}{utils.formatQuantity(amount, 2)}</p>
                        <div className='d-flex'>
                            <img className='my-auto me-1' src={process.env.PUBLIC_URL + `/img/arrow-${isIncrease ? 'up' : 'down'}.png`} alt={isIncrease ? 'Increase' : 'Decrease'} style={{ height: 'fit-content' }} />
                            <p className={`color-${isIncrease ? 'success' : 'danger'} fw-bold mb-0`}>{changeValue}{proportionChange ? 'X' : '%'}</p>
                            <p className='ms-1 mb-0'>{utils.formatPeriod(period)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResumeQuantity;